import { VehicleDetail } from './VehicleDetail';

export interface PlateDisambiguationOption {
  stammNr: string;
  brand: string;
  kind?: string;
  vehicleType?: string;
  plateColor?: string;
  label: string;
}

export interface PlateDisambiguationResponse {
  disambiguationRequired: true;
  options: PlateDisambiguationOption[];
}

export type PlateSearchResponse = PlateDisambiguationResponse | VehicleDetail[];

export function isPlateDisambiguationResponse(
  response: PlateSearchResponse
): response is PlateDisambiguationResponse {
  return !Array.isArray(response) && response.disambiguationRequired === true;
}
